import { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/HeaderComponents/Header/header";
import Footer from "./components/FooterComponents/Footer/footer";
import AppRoutes from "./routes";
import AdminPanel from "./pages/Admin/admin-panel";

function App() {
  const currentPath = window.location.pathname;

  const [page, setPage] = useState<string>("");

  const onHandlePages = (newPage: string) => {
    return setPage(newPage);
  };

  useEffect(() => {
    if (currentPath === "/") {
      return setPage("HOME");
    }

    if (currentPath === "/admin") {
      return setPage("ADMIN");
    }

    return setPage(currentPath.split("/")[1].toUpperCase());
  }, [currentPath]);

  return (
    <>
      {page === "ADMIN" ? (
        <div className="App">
          <Routes>
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </div>
      ) : (
        <div className="App">
          <Header page={page} onHandlePages={onHandlePages} />
          <AppRoutes page={page} onHandlePages={onHandlePages} />
          <Footer onHandlePages={onHandlePages} />
        </div>
      )}
    </>
  );
}

export default App;
